import { ScreenBase } from "@frui.ts/screens";
import { interfaces } from "inversify";
import { computed } from "mobx";
import ChargeTypesService from "services/chargeTypesService";
import LocalizationService from "services/localizationService";
import ChargeTypeViewModel from "../eshop/order/components/chargeViewModel";
import { getValidationMessage } from "../../utils/validationPatch";
import { bound } from "@frui.ts/helpers/dist";
import ChargeOrderChargeItem from "models/chargeOrderChargeItem";
import EnumService from "services/enumService";
import ChargeTypeResponse from "entities/chargeTypeResponse";
import { validityDays } from "entities/chargeValidity";
import ChargeOrderItem from "models/chargeOrderItem";
import ChargeOrderService from "services/chargeOrderService";
import { observable } from "mobx";

// @TODO Měl by to být ConductorAllChildrenActive
export default class ChargeTypeSelectViewModel extends ScreenBase {
  @observable batchIndex: number | undefined;
  protected unsubscriptions: Array<() => void> = [];
  constructor(
    public chargeOrderChargeItem: ChargeOrderChargeItem | ChargeOrderItem,
    public chargeOrderChargeItemId: string | undefined,
    public localizationService: LocalizationService,
    public enumService: EnumService,
    private chargeViewModelFactory: ReturnType<typeof ChargeTypeViewModel.Factory>,
    private chargeTypesService: ChargeTypesService,
    private chargeOrderService: ChargeOrderService
  ) {
    super();
  }

  @computed
  get chargeTypes() {
    return this.enumService.values("charge_types") as ChargeTypeResponse[];
  }

  protected onDeactivate(isClosing: boolean) {
    if (isClosing) {
      this.unsubscriptions.forEach(unsubscribe => unsubscribe());
      this.unsubscriptions = [];
    }

    return super.onDeactivate(isClosing);
  }

  @computed
  get chargeTypeViewModels() {
    const validChargeTypes = this.chargeTypes
      .filter(
        chargeType =>
          this.chargeTypesService.chargePriceList?.includedChargeTypeIds.includes(chargeType.id.toString()) &&
          !chargeType.isDeleted
      )
      .sort((chargeA, chargeB) => (validityDays(chargeA.validFor) > validityDays(chargeB.validFor) ? -1 : 1));
    return validChargeTypes.map(item =>
      this.chargeViewModelFactory(item, this.chargeOrderChargeItem, this.chargeOrderChargeItemId)
    );
  }

  @computed
  get showLabel() {
    return this.chargeOrderService.chargeOrder._origin !== "multiple" && this.chargeOrderService.chargeOrder._origin !== "single";
  }

  @computed
  get chargeTypeError() {
    return getValidationMessage(this.chargeOrderChargeItem, "chargeTypeId");
  }

  @computed
  get isInitialized() {
    return this.chargeTypesService.isInitialized;
  }

  @bound
  ta(code: string) {
    return this.localizationService.translateAttribute("orderItem", code);
  }

  static Factory({ container }: interfaces.Context) {
    return (chargeOrderChargeItem: ChargeOrderChargeItem | ChargeOrderItem, chargeOrderChargeItemId?: string) =>
      new ChargeTypeSelectViewModel(
        chargeOrderChargeItem,
        chargeOrderChargeItemId,
        container.get(LocalizationService),
        container.get(EnumService),
        container.get(ChargeTypeViewModel.Factory),
        container.get(ChargeTypesService),
        container.get(ChargeOrderService)
      );
  }
}
